import { render, staticRenderFns } from "./ProductVariantNewPopup.vue?vue&type=template&id=b22dfadc&"
import script from "./ProductVariantNewPopup.vue?vue&type=script&lang=js&"
export * from "./ProductVariantNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports